import * as React from "react";
import { DocumentTitle, Spinner } from "components/common";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import WizardPageHeader from "./WizardPageHeader";
import { HELP, AUTH_BACKEND_META } from "./BackendCreate";
import prepareInitialWizardValues from "../PrepareInitialWizardValues";
import BackendWizard from "../BackendWizard";
import handleUpdate from "../HandleUpdate";
const _optionalWizardProps = (initialStepKey) => ({ initialStepKey });
const BackendEdit = ({ authenticationBackend, initialStepKey }) => {
  var _a, _b;
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const {
    help: groupSyncHelp = {},
    excludedFields: groupSyncExcludedFields = {},
    initialValues: initialGroupSyncValues = {}
  } = (_b = (_a = enterpriseGroupSyncPlugin == null ? void 0 : enterpriseGroupSyncPlugin.wizardConfig) == null ? void 0 : _a.activeDirectory) != null ? _b : {};
  const help = { ...HELP, ...groupSyncHelp };
  const excludedFields = { ...groupSyncExcludedFields, userUniqueIdAttribute: true, emailAttributes: true };
  let initialValues = prepareInitialWizardValues(authenticationBackend);
  if (enterpriseGroupSyncPlugin) {
    const { formValues: groupFormValues, finishedLoading } = enterpriseGroupSyncPlugin.hooks.useInitialGroupSyncValues(
      authenticationBackend.id,
      initialGroupSyncValues
    );
    if (!finishedLoading) {
      return /* @__PURE__ */ React.createElement(Spinner, null);
    }
    initialValues = { ...initialValues, ...groupFormValues };
  }
  const authBackendMeta = {
    ...AUTH_BACKEND_META,
    backendId: authenticationBackend.id,
    backendHasPassword: authenticationBackend.config.systemUserPassword.isSet,
    backendGroupSyncIsActive: !!initialValues.synchronizeGroups
  };
  const _handleSubmit = (payload, formValues, serviceType, shouldUpdateGroupSync) => handleUpdate(
    payload,
    formValues,
    authenticationBackend.id,
    !!initialValues.synchronizeGroups,
    serviceType,
    shouldUpdateGroupSync
  );
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Edit Active Directory Authentication Service" }, /* @__PURE__ */ React.createElement(WizardPageHeader, { authenticationBackend }), /* @__PURE__ */ React.createElement(
    BackendWizard,
    {
      ..._optionalWizardProps(initialStepKey),
      authBackendMeta,
      excludedFields,
      help,
      initialValues,
      onSubmit: _handleSubmit
    }
  ));
};
export default BackendEdit;
